import PropTypes from 'prop-types';

import { Card, MinusPlusButtons, OverlayTriggerTooltip } from '@utilities';
import { CREDIT_TYPES } from '@api/client/utilities/constants';

import RenderDiffBox from './components/RenderDiffBox';
import { updateCardValue } from './utilities/helpers';

import styles from './_index.module.scss';

const ClientCreditCards = ({
  cards,
  isEditable,
  originalHoldForFutureProjects,
  setClientCredits,
  unassignedCredits,
}) => {
  const visibleCards = Array.isArray(cards)
    ? cards.filter((card) => card.isDisplayed !== false)
    : [];

  return (
    <div className={styles['credit-management-cards']}>
      {visibleCards.map(({ isUpdateable, label, tooltip, type, value }, index) => {
        const status = value < 0 ? 'error' : 'success';
        const diff =
          type === CREDIT_TYPES.HOLD_FOR_FUTURE && originalHoldForFutureProjects !== null
            ? value - originalHoldForFutureProjects
            : 0;

        return (
          <Card key={type} padding="small" status={status}>
            <div className={styles['credit-management-card-col']}>
              <p>
                <OverlayTriggerTooltip content={tooltip}>{label}</OverlayTriggerTooltip>
                {': '}
                {(!isEditable || (isEditable && !isUpdateable)) && (
                  <span className={styles['credit-management-card-value']}>
                    {value?.toLocaleString?.() ?? 0}
                  </span>
                )}
              </p>

              {isEditable && isUpdateable && (
                <div className={styles['credit-management-card-row']}>
                  <RenderDiffBox position="left" value={diff} />
                  <span className={styles['minus-plus-buttons']}>
                    <MinusPlusButtons
                      disableMinusButton={value <= 0}
                      hasMinusButton={true}
                      hasPlusButton={false}
                      isNeutral={value === 0}
                      onClickMinus={() => {
                        if (!isEditable) return;
                        setClientCredits((prev) => updateCardValue(prev, -1, index));
                      }}
                    />
                  </span>
                  <span className={styles['credit-management-card-value']}>
                    {value?.toLocaleString?.() ?? 0}
                  </span>
                  <span className={styles['minus-plus-buttons']}>
                    <MinusPlusButtons
                      disablePlusButton={unassignedCredits <= 0}
                      hasMinusButton={false}
                      hasPlusButton={true}
                      onClickPlus={() => {
                        if (!isEditable) return;
                        setClientCredits((prev) =>
                          updateCardValue(prev, 1, index, unassignedCredits)
                        );
                      }}
                    />
                  </span>
                  <RenderDiffBox position="right" value={diff} />
                </div>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
};

ClientCreditCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      isDisplayed: PropTypes.bool,
      isUpdateable: PropTypes.bool,
      label: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
      type: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ).isRequired,
  isEditable: PropTypes.bool,
  originalHoldForFutureProjects: PropTypes.number,
  setClientCredits: PropTypes.func.isRequired,
  unassignedCredits: PropTypes.number,
};

export default ClientCreditCards;
